export const fontScaleFactors = {
  small: 0.8,
  medium: 1.0,
  large: 1.2,
};

export type FontSizePreset = keyof typeof fontScaleFactors;

export const scaleFontSize = (
  baseSize: number,
  preset: FontSizePreset = "medium",
): number => {
  return Math.round(baseSize * fontScaleFactors[preset]);
};
